export class CustomerNotLoggedInError extends Error {
  constructor(message = "User is not logged in") {
    super(message);
    this.name = "CustomerNotLoggedIn";
  }
}

/**
 * Get current customer JWT authenticating with internal APIs
 * @param {*} apiAccountClientId
 * @returns {Promise<string|null>}
 */
export async function getCustomerJwt(apiAccountClientId) {
  let resource = `/customer/current.jwt?app_client_id=${apiAccountClientId}`;
  let response = await fetch(resource);

  if (response.status !== 200) {
    throw new CustomerNotLoggedInError();
  }

  return await response.text();
}
